<template>
  <div>
    <el-tabs v-model="activeName" type="card">
      <el-tab-pane
        v-for="item in tabMapOptions"
        :key="item.key"
        :label="item.label"
        :name="item.key"
      >
        <component :is="activeName" v-if="activeName === item.key" :ref="item.key" />
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
  import Trade from './components/trade/index.vue';
  import MultimodalTransport from './components/multimodalTransport/index.vue';
  // import parkWarehouse from './components/parkWarehouse/index.vue';
  import parkProperty from './components/parkProperty/index.vue';
  import LeaseContract from './components/LeaseContract/index.vue';
  import ChengkuangTrad from './components/chengkuangTrad/index.vue';
  export default {
    name: 'payables',
    components: {
      Trade,
      MultimodalTransport,
      // parkWarehouse,
      parkProperty,
      LeaseContract,
      ChengkuangTrad,
    },
    data() {
      return {
        activeName: 'Trade',
        judgeActiveName: 'MultimodalTransport',
        tabMapOptions: [
          { label: '贸易', key: 'Trade' },
          { label: '多式联运', key: 'MultimodalTransport' },
          // { label: '园区仓储', key: 'parkWarehouse' },
          { label: '园区物业', key: 'parkProperty' },
          { label: '三方租赁', key: 'LeaseContract' },
          { label: '城矿', key: 'ChengkuangTrad' },
        ],
      };
    },
    mounted() {
      this.$nextTick(() => {
        if (
          [
            '供应链运输事业部',
            '广西物产桂储物流有限公司',
            '广西物产供应链管理有限公司',
            '柳州市桂中海迅运输有限公司',
            '广西桂物通物流有限公司',
            '广西物产桂储物流有限公司成都分公司',
            '广西物产桂储物流有限公司天津分公司',
          ].includes(this.userInfo.companyName)
        ) {
          this.activeName = 'MultimodalTransport';
        } else if (this.userInfo.businessGroup == '城矿') {
          this.activeName = 'ChengkuangTrad';
        } else {
          this.activeName = 'Trade';
        }
      });
    },
  };
</script>

<style lang="scss" scoped>
  ::v-deep {
    .el-tabs__header {
      margin: 0px !important;
    }
    .el-tabs--card > .el-tabs__header .el-tabs__item.is-active {
      border-bottom: none;
      background: #fff;
    }
    .el-tabs--card > .el-tabs__header .el-tabs__nav {
      background: #ebf3fe;
      border-bottom: 1px solid #e4e7ed;
    }
  }
</style>
